export default "__VITE_ASSET__BHzN18c___"